import { useForm } from "react-hook-form";
import usePostHook from "../../customHooks/usePostHook";
import Button from "../Reusable/Button";
import TextField from "../Reusable/TextInput";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import APIS from "../../constant/Endpoint";
import { useQueryClient } from "@tanstack/react-query";
const EditDeliveryCharge = (props: any) => {
  const queryClient = useQueryClient();
  const { register, handleSubmit, setError } = useForm({
    defaultValues: async () => {
      return {
        charge: props?.chargevalue,
      };
    },
  });
  const {
    id,
    disabled = false,
    setOpenDeliveryModal,
    openDeliveryModal,
  } = props;
  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["orders"],
    navigateURL: "",
  });

  const handleDeliverychargeEdit = async (value) => {
    const url = `${APIS.ORDER}update-delivery-charge/`;
    let formData = {
      ...value,
      charge_for: props?.type,
      order: id,
    };
    try {
      const res = await mutateAsync({ url, formData, setError });
      if (res?.status === 200) {
        setOpenDeliveryModal(!openDeliveryModal);
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <form
      onSubmit={handleSubmit((data: any) => handleDeliverychargeEdit(data))}
      autoComplete="off"
    >
      <div>
        <TextField
          register={register("charge")}
          placeholder={"Enter the Delivery Charge"}
        />
        <div className={tw`flex justify-end w-full`}>
          <div className={tw`w-[100px]`}>
            <Button
              label={"Update"}
              isLoading={isPostLoading}
              disabled={disabled}
            />
          </div>
        </div>
      </div>
    </form>
  );
};

export default EditDeliveryCharge;
